module.exports = __webpack_public_path__ + "80da94416d959420c10c3b2a42f90179.webm";


//////////////////
// WEBPACK FOOTER
// ./assets/tutorials/blocks.webm
// module id = +If5
// module chunks = 0